import "./form.scss";
export default {
  props: {
    components: {
      type: Object,
      required: false,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      validateRules: [],
      loading: false,
    };
  },
  computed: {
    formAttrs() {
      const attrs = {
        buttons: [
          {
            type: "reset",
            text: "取消",
          },
          {
            type: "submit",
            text: "确认",
          },
        ],
        inline: false,
        labelPosition: "right",
        labelWidth: "auto",
        disabled: false,
        size: "medium",
        buttonsAlign: "left",
        showColon: true,
        ...this.$COMMONUI.formOptions,
      };
      for (const key in attrs) {
        if (Object.prototype.hasOwnProperty.call(this.option, key)) {
          attrs[key] = this.option[key];
        }
      }
      return attrs;
    },
  },
  methods: {
    changeLoading(loading) {
      this.loading = loading;
    },
    addValidateRules(rule) {
      this.validateRules.push(rule);
    },
    removeValidateRules(rule) {
      const idx = this.validateRules.indexOf(rule);
      this.validateRules.splice(idx, 1);
    },
    async onSubmit(callback) {
      if (this.loading === true) {
        return;
      }
      for (const validateRule of this.validateRules) {
        const flag = await validateRule();
        if (flag === false) {
          return false;
        }
      }
      this.$refs.form.validate((valid) => {
        if (valid) {
          const formData = this.ruleList.reduce((formData, item) => {
            if (item.hidden === true) {
              return formData;
            } else if (item.condition && !item.condition(this.formData)) {
              return formData;
            }
            formData[item.field] = this.formData[item.field];
            return formData;
          }, {});
          callback && callback(formData, this.changeLoading);
          this.$emit("submit", formData, this.changeLoading);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    onReset(callback) {
      // loading状态，不允许点击取消按钮
      if (!this.loading) {
        this.$refs.form.resetFields();
        callback && callback();
        this.$emit("reset");
      }
    },
  },
};
